/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Vchip_DialogueInputs */



/**
* | output |
* | --- |
* | "Suggestive Dialogue" |
*
* @param {Subtitle_Export_Vchip_DialogueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_vchip_dialogue = /** @type {((inputs?: Subtitle_Export_Vchip_DialogueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Vchip_DialogueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dialogue suggestif")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anregender Dialog")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dialogo suggestivo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Намекающий диалог")
	if (locale === "es") return /** @type {LocalizedString} */ ("Diálogo sugerente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("暗示性对话")
	if (locale === "ja") return /** @type {LocalizedString} */ ("示唆的な会話")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संकेतात्मक संवाद")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Diálogo sugestivo")
	return /** @type {LocalizedString} */ ("Suggestive Dialogue")
});